import styled from "styled-components";

export const ModalContainer = styled.div`
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
    display: flex;
    gap: 16px;
    padding: 20px;
    align-items: flex-start;
`;

export const IconContainer = styled.div`
    width: 36px;
    height: 36px;
    flex-shrink: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    background: #fef2f2;

    font-size: 18px;
`;

export const IconCircle = styled.div`
    width: 36px;
    height: 36px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #f5f5f5;
    border-radius: 50%;

    color: #6a7282;
    font-size: 18px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #101828;
`;

export const Description = styled.p`
    margin: 0;
    color: #6a7282;
    font-size: 14px;
    line-height: 22px;
`;

export const GatewayName = styled.span`
    color: #1e2939;
    font-weight: 600;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    padding: 20px;

    border-top: 1px solid #ebebeb;
`;

export const CancelButton = styled.button`
    height: 34px;
    padding: 8px 16px;

    border-radius: 8px;
    border: 1px solid #d6d6d6;

    background: #fff;

    cursor: pointer;

    font-weight: 600;

    &:hover {
        background: #fafafa;
    }
`;

export const DeleteButton = styled.button`
    height: 34px;
    padding: 8px 16px;

    border: none;
    border-radius: 8px;

    background: #fb2c36;
    color: #fff;

    cursor: pointer;

    font-weight: 600;

    &:hover {
        background: #e11d2e;
    }
`;
